import { FaEdit, FaTrash } from 'react-icons/fa';

function ActionsTable({
  handleEdit = () => {},
  handleDelete = () => {},
  canEdit = true,
  canDelete = true,
  canSwitch = false,
  enabled = false,
  setEnabled = () => {},
  tienePermisoEliminar = null,
  tienePermisoEditar = null,
  onChangeSwitch = () => {},
}) {
  return (
    <div className="actions-table-main-div">
      {/* Switch */}
      {canSwitch && tienePermisoEditar && (
        <label className="actions-table-label-switch">
          <input
            type="checkbox"
            disabled={enabled === true}
            checked={enabled}
            onChange={(e) => onChangeSwitch(e.target.checked)}
            className="peer sr-only"
          />

          <div className="actions-table-div-body-switch" />

          <div className="actions-table-div-circle-switch" />
        </label>
      )}
      {/* Editar */}
      {canEdit && tienePermisoEditar && (
        <button className="btn-action-edit" title="Editar" onClick={() => handleEdit()}>
          <FaEdit className="icon-btn-action-edit" />
        </button>
      )}

      {/* Eliminar */}
      {canDelete && tienePermisoEliminar && (
        <button className="btn-action-delete" title="Eliminar" onClick={() => handleDelete()}>
          <FaTrash className="icon-btn-action-delete" />
        </button>
      )}
    </div>
  );
}

export default ActionsTable;
